module.exports = __webpack_public_path__ + "static/media/logout icon (active).0065720f.svg";